// src/hooks/useStickyNavbar.ts
import { useEffect } from "react";

type StickyOpts = {
  navbarSelector?: string;        // ".primary-navbar"
  progressWrapSelector?: string;  // ".progress-wrap"  (optional)
  activeClass?: string;           // "navbar-active"
  progressActiveClass?: string;   // "active-progress"
  threshold?: number;             // 100
};

export function useStickyNavbar(opts: StickyOpts = {}) {
  const {
    navbarSelector = ".primary-navbar",
    progressWrapSelector = ".progress-wrap",
    activeClass = "navbar-active",
    progressActiveClass = "active-progress",
    threshold = 100,
  } = opts;

  useEffect(() => {
    if (typeof window === "undefined") return;

    const navbarEl = document.querySelector<HTMLElement>(navbarSelector);
    const progressEl = document.querySelector<HTMLElement>(progressWrapSelector);

    const applyInitial = () => {
      const y = window.scrollY || 0;
      if (navbarEl) {
        if (y >= threshold) navbarEl.classList.add(activeClass);
        else navbarEl.classList.remove(activeClass);
      }
      if (progressEl) {
        if (y >= threshold) progressEl.classList.add(progressActiveClass);
        else progressEl.classList.remove(progressActiveClass);
      }
    };

    const onScroll = () => {
      const y = window.scrollY || 0;
      if (navbarEl) {
        if (y >= threshold) navbarEl.classList.add(activeClass);
        else navbarEl.classList.remove(activeClass);
      }
      if (progressEl) {
        if (y >= threshold) progressEl.classList.add(progressActiveClass);
        else progressEl.classList.remove(progressActiveClass);
      }
    };

    const onResize = () => {
      // header-related reset for menu handled in useMobileMenu
      applyInitial();
    };

    // initial
    applyInitial();

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
    };
  }, [navbarSelector, progressWrapSelector, activeClass, progressActiveClass, threshold]);
}
